import SlButton from '@shoelace-style/shoelace/dist/react/button';
import React from 'react';
import { useNavigate } from 'react-router-dom';


const css = `
  .terms-wrapper {
    max-width: 900px;
    margin: 40px auto;
    padding: 48px;
    box-shadow: 0 2px 14px #0000000f;

    .app-header {
        text-align: right;
        border-bottom: 1px solid lightgray;
        gap: 17px;
        display: flex;
        flex-direction: column;
        justify-content: end;
    }

    .app-header-left {
        text-align: right;
        gap: 17px;
        display: flex;
        flex-direction: row;
        justify-content: end;
    }
    .app-header-left > img {
        width: 93px;
        margin-bottom: 15px;
    }

    @media screen and (min-width: 900px) {
        .app-header {
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            .app-header-right {
                text-align: right;
                gap: 17px;
                display: flex;
                flex-direction: row;
                justify-content: end;
            }
        }
    }
  }

  h1 {
    font-size: 34px;
  }

  h2 {
    margin-top: 34px;
    font-size: 22px;
  }

  li {
    margin: 7px 0;
  }

  .meta {
    margin-bottom: 30px;
  }

  .notice {
    border-left: 4px solid #1f6f5c;
    padding: 16px 18px;
    margin: 22px 0;
  }

  .contact {
    padding: 20px;
  }


  @media (max-width: 700px) {
    .terms-wrapper {
      margin: 0;
      padding: 28px 20px;
      box-shadow: none;
    }

    h1 {
      font-size: 29px;
    }
  }
`;

const Terms = () => {
    const navigate = useNavigate();
  return (
    <div className="terms-wrapper">
        <header className="app-header">
                      <div className="app-header-left">
                      <img
                            slot="image"
                            src="./images/LogoSerale.png"
                            alt="JADU."
                          />
                      <SlButton variant="primary" onClick={() => navigate('/')}>
                          Home
                        </SlButton>
                        </div>
                
                        <div className="app-header-right">
                
                       
                         
                          </div>
                      </header>
      <h1>HomeKeepy Terms of Service</h1>
      <div className="meta">
        <strong>Effective Date:</strong> October 30, 2026
        <br />
        <strong>Last Updated:</strong> October 30, 2026
      </div>

      <p>
        Welcome to <strong>HomeKeepy</strong>. These Terms of Service (“Terms”) govern your
        access to and use of the HomeKeepy website, mobile applications, software, and related
        services (collectively, the “Service”).
      </p>
      <p>
        By creating an account, accessing, or using HomeKeepy, you agree to these Terms. If you
        do not agree to these Terms, you may not use the Service.
      </p>

      <h2>1. About HomeKeepy</h2>
      <p>
        HomeKeepy is a technology platform designed to help property owners, property managers,
        residents, tenants, and service providers manage home-related information, maintenance,
        repairs, communications, and related services.
      </p>
      <p>Depending on your account and available features, HomeKeepy may allow you to:</p>
      <ul>
        <li>Submit and track maintenance and repair requests.</li>
        <li>Communicate with property owners, property managers, residents, tenants, and service providers.</li>
        <li>Access property, lease, contract, and maintenance information.</li>
        <li>Upload photographs, documents, and other information.</li>
        <li>Receive notifications and communications.</li>
        <li>Use supported payment services for eligible property or service transactions.</li>
        <li>Communicate with an AI-powered HomeKeepy assistant.</li>
        <li>Receive information regarding maintenance, repairs, and home-related services.</li>
        <li>Coordinate or request services from contractors or other service providers.</li>
      </ul>
      <p>HomeKeepy may add, modify, or discontinue features from time to time.</p>

      <h2>2. Eligibility</h2>
      <p>
        You must be legally capable of entering into a binding agreement to use HomeKeepy. If
        you use HomeKeepy on behalf of an organization, you represent that you have authority to
        accept these Terms on its behalf. HomeKeepy is not intended for children under 13.
      </p>

      <h2>3. Your HomeKeepy Account</h2>
      <p>
        Some features require an account. You agree to provide accurate information, protect your
        credentials, not share your account with unauthorized individuals, promptly report
        suspected compromise, and accept responsibility for activity through your account. You
        may not create an account using false information or impersonate another person or
        organization.
      </p>
      <p>
        HomeKeepy may suspend or terminate accounts that violate these Terms or create security,
        legal, or operational risks.
      </p>

      <h2>4. Maintenance and Repair Requests</h2>
      <p>
        HomeKeepy may allow users to submit requests concerning maintenance, repairs,
        appliances, property conditions, or other home-related issues. You agree to provide
        reasonably accurate and complete information.
      </p>
      <ul>
        <li>Submitting a request does not necessarily mean it has been approved.</li>
        <li>HomeKeepy does not guarantee a repair will be performed within a particular timeframe.</li>
        <li>Contractor or service-provider availability may vary.</li>
        <li>Additional information, photographs, inspections, or authorization may be required.</li>
        <li>Certain repairs may require approval from an owner, manager, insurer, or other authorized party.</li>
      </ul>
      <div className="notice">
        <strong>Emergencies:</strong> For fire, gas leaks, flooding, medical emergencies,
        crime, or immediate danger to people or property, do not rely solely on HomeKeepy.
        Contact the appropriate emergency service or qualified professional immediately.
      </div>

      <h2>5. Contractors and Service Providers</h2>
      <p>
        HomeKeepy may facilitate communications or interactions with independent contractors,
        technicians, vendors, or other service providers. Unless expressly stated otherwise,
        these providers may be independent third parties and are not HomeKeepy employees.
      </p>
      <p>
        HomeKeepy does not guarantee the availability, qualifications, licensing, insurance,
        performance, quality, timing, cost, or outcome of third-party services. Users should
        independently verify licensing, insurance, qualifications, pricing, and other
        information where appropriate. If HomeKeepy directly provides a maintenance or repair
        service, additional service-specific terms may apply.
      </p>

      <h2>6. AI Assistant</h2>
      <p>
        HomeKeepy may provide an AI-powered assistant to help users obtain information,
        communicate, navigate the platform, and understand home, maintenance, lease, or
        property-related information.
      </p>
      <p>
        The AI assistant is provided as a convenience and <strong>does not replace a qualified
        professional</strong>. AI-generated responses may contain errors, omissions, or outdated
        information; should not be relied upon as legal, medical, financial, safety,
        engineering, or other professional advice; should be independently verified when
        accuracy matters; and do not create a professional-client relationship.
      </p>
      <p>
        Do not rely on the AI assistant to determine whether an emergency exists or whether a
        property condition presents an immediate threat to health or safety. HomeKeepy may use
        third-party AI providers as described in the Privacy Policy.
      </p>

      <h2>7. Lease, Contract, and Property Information</h2>
      <p>
        HomeKeepy may allow users to store, access, display, or review leases, contracts,
        property records, maintenance histories, and other documents. HomeKeepy is a technology
        platform and does not provide legal advice. Availability of a document through HomeKeepy
        does not mean HomeKeepy has verified its accuracy, validity, enforceability, or legal
        sufficiency. Users are responsible for reviewing important documents and obtaining
        professional advice when appropriate.
      </p>

      <h2>8. Free Trial, Subscriptions, and Payments</h2>
      <p>
        Creating a HomeKeepy account is free. Each new user receives a 30-day free trial, whether
        the account is created on the HomeKeepy website or in the iOS application. No subscription
        charge is due during the trial, and the trial does not automatically convert to a paid
        subscription. If you choose to continue after the trial, you must select and purchase a
        plan through the HomeKeepy website. HomeKeepy does not offer in-app purchases or process
        subscription payments in its iOS application.
      </p>
      <p>
        HomeKeepy currently offers these monthly subscription plans: <strong>HomeKeepy 1–5 Units</strong>
        for $30 per month, for managing one to five residential units; and <strong>HomeKeepy 6–10 Units</strong>
        for $60 per month, for managing six to ten residential units. Subscription plans are
        purchased and managed through <a href="https://www.homekeepy.com">www.homekeepy.com</a>.
        Payments and recurring monthly billing are processed securely through Stripe. Subscription
        access and plan entitlements are associated with your HomeKeepy account and may be accessed
        through the website and iOS application using the same login credentials.
      </p>
      <p>
        Subscription payments are separate from any eligible property or service-provider payment
        functionality available through HomeKeepy. Payments processed by Stripe or another
        supported provider may be subject to that provider’s terms and policies. HomeKeepy does not
        guarantee successful processing and is not responsible for errors caused by banks, card
        networks, payment processors, or other financial institutions. Unless expressly stated
        otherwise, HomeKeepy does not hold funds on behalf of users.
      </p>

      <h2>9. Communications and Text Messages</h2>
      <p>
        By providing your telephone number and using communications features, you may receive
        maintenance updates, appointment information, account notifications, security or
        authentication messages, property-related communications, and service updates. Where
        applicable, users may opt out of certain promotional communications, but transactional,
        security, or service-related messages may still be necessary. Message and data rates may
        apply.
      </p>

      <h2>10. User Content</h2>
      <p>
        You may submit text, messages, maintenance descriptions, photographs, documents,
        property information, repair information, feedback, and other materials. You retain
        ownership of your content, subject to the rights necessary for HomeKeepy to operate the
        Service.
      </p>
      <p>
        By submitting content, you grant HomeKeepy a non-exclusive, worldwide, royalty-free
        license to host, store, reproduce, process, transmit, display, and use that content as
        reasonably necessary to provide, maintain, secure, and improve the Service. You
        represent that you have the rights and permissions needed to submit the content. You
        must not upload unlawful, fraudulent, defamatory, threatening, infringing, or otherwise
        unlawful content.
      </p>

      <h2>11. Prohibited Activities</h2>
      <ul>
        <li>Violating applicable law or regulation.</li>
        <li>Impersonating another person.</li>
        <li>Accessing another user’s account without authorization.</li>
        <li>Bypassing security controls.</li>
        <li>Interfering with the Service.</li>
        <li>Introducing malware, viruses, or harmful code.</li>
        <li>Scraping or systematically collecting information without authorization.</li>
        <li>Reverse engineering except where permitted by law.</li>
        <li>Harassing, threatening, or abusing another person.</li>
        <li>Submitting fraudulent maintenance or repair requests.</li>
        <li>Uploading content that infringes another person’s rights.</li>
        <li>Using HomeKeepy for fraudulent or illegal purposes.</li>
      </ul>

      <h2>12. Intellectual Property</h2>
      <p>
        HomeKeepy and its software, technology, designs, logos, trademarks, graphics, text,
        interfaces, and other materials are owned by or licensed to HomeKeepy and protected by
        applicable law. Except as expressly permitted by these Terms, you may not copy,
        modify, distribute, sell, license, reverse engineer, or create derivative works from
        the Service or its content.
      </p>

      <h2>13. Third-Party Services</h2>
      <p>
        HomeKeepy may integrate with or rely on third-party services, including payment,
        communications, infrastructure, analytics, authentication, and AI providers. These may
        include OpenAI, Stripe, and Twilio. Your use of certain third-party services may also
        be subject to their terms and privacy policies. HomeKeepy is not responsible for
        third-party services it does not control.
      </p>

      <h2>14. Privacy</h2>
      <p>
        Your use of HomeKeepy is also governed by the <strong>HomeKeepy Privacy Policy</strong>.{' '}
        <a href="https://www.homekeepy.com/privacy">View the Privacy Policy</a>.
      </p>

      <h2>16. Availability of the Service</h2>
      <p>
        HomeKeepy strives to provide a reliable service but does not guarantee that it will
        always be available, uninterrupted, secure, or error-free. Service interruptions may
        result from maintenance, updates, technical problems, telecommunications failures,
        third-party outages, security incidents, or events beyond HomeKeepy’s reasonable
        control. HomeKeepy may modify, suspend, or discontinue portions of the Service.
      </p>

      <h2>17. Disclaimers</h2>
      <p>
        <strong>TO THE MAXIMUM EXTENT PERMITTED BY LAW, THE HOMEKEEPY SERVICE IS PROVIDED ON AN
        “AS IS” AND “AS AVAILABLE” BASIS.</strong>
      </p>
      <p>
        HomeKeepy disclaims warranties of any kind, whether express, implied, or statutory,
        including warranties of merchantability, fitness for a particular purpose, title,
        non-infringement, accuracy, and availability. HomeKeepy does not guarantee that the
        Service will meet your requirements, information will always be accurate,
        AI-generated information will be error-free, repairs will be completed within a
        particular timeframe, or third-party providers will meet your expectations. Nothing
        excludes warranties or rights that cannot legally be excluded.
      </p>

      <h2>18. Limitation of Liability</h2>
      <p>
        <strong>TO THE MAXIMUM EXTENT PERMITTED BY LAW, HOMEKEEPY AND ITS OWNERS, OFFICERS,
        EMPLOYEES, AFFILIATES, CONTRACTORS, AND SERVICE PROVIDERS WILL NOT BE LIABLE FOR
        INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, EXEMPLARY, OR PUNITIVE DAMAGES ARISING
        FROM OR RELATED TO YOUR USE OF THE SERVICE.</strong>
      </p>
      <p>
        <strong>TO THE MAXIMUM EXTENT PERMITTED BY LAW, HOMEKEEPY’S TOTAL LIABILITY ARISING OUT
        OF OR RELATING TO THE SERVICE WILL NOT EXCEED THE GREATER OF: (1) THE AMOUNT YOU PAID
        TO HOMEKEEPY FOR THE SERVICE DURING THE TWELVE MONTHS BEFORE THE EVENT GIVING RISE TO
        THE CLAIM; OR (2) $100.</strong>
      </p>
      <p>
        Some jurisdictions do not permit certain limitations of liability, so some limitations
        may not apply to you.
      </p>

      <h2>19. Indemnification</h2>
      <p>
        To the maximum extent permitted by law, you agree to defend, indemnify, and hold
        harmless HomeKeepy and its owners, officers, employees, affiliates, contractors, and
        service providers from claims, damages, liabilities, losses, costs, and expenses
        arising from your violation of these Terms, misuse of the Service, User Content,
        violation of another person’s rights, violation of applicable law, or unauthorized use
        of another person’s account.
      </p>

      <h2>20. Termination</h2>
      <p>
        You may stop using HomeKeepy at any time. HomeKeepy may suspend or terminate access if
        you violate these Terms, create a security or legal risk, engage in fraudulent activity,
        if required by law, or if the applicable Service is discontinued. Provisions that by
        their nature should survive termination will survive.
      </p>

      <h2>21. Changes to These Terms</h2>
      <p>
        HomeKeepy may update these Terms from time to time. We may update the “Last Updated”
        date and, where appropriate, provide additional notice. Continued use after revised
        Terms become effective constitutes acceptance to the extent permitted by law.
      </p>

      <h2>22. Governing Law</h2>
      <p>
        These Terms are governed by the laws of the <strong>State of California</strong>,
        without regard to conflict-of-law principles, except where applicable law requires
        otherwise.
      </p>

      <h2>23. Dispute Resolution</h2>
      <p>
        Before initiating a formal legal proceeding, you agree to first contact HomeKeepy and
        provide a reasonable opportunity to resolve the dispute informally. Nothing prevents a
        party from seeking emergency or injunctive relief where appropriate or exercising rights
        that cannot legally be waived.
      </p>
      <div className="notice">
        <strong>Legal review recommended:</strong> Final dispute-resolution language, including
        arbitration, class-action waivers, and venue, should be reviewed by a California
        attorney before publication.
      </div>

      <h2>24. Apple App Store Users</h2>
      <p>If you download or use the HomeKeepy mobile application through Apple’s App Store:</p>
      <ul>
        <li>These Terms are between you and HomeKeepy, not Apple.</li>
        <li>Apple is not responsible for the HomeKeepy application or its content.</li>
        <li>Apple has no obligation to provide maintenance or support for the application.</li>
        <li>Apple is not responsible for addressing claims relating to the application.</li>
        <li>Apple is a third-party beneficiary of these Terms and may enforce applicable provisions relating to the App Store.</li>
      </ul>
      <p>Your use of the application must also comply with applicable App Store rules and policies.</p>

      <h2>25. Contact Us</h2>
      <div className="contact">
        <strong>HomeKeepy</strong>
        <br />
        Website: <a href="https://www.homekeepy.com/">www.homekeepy.com</a>
        <br />
        Email: <a href="mailto:admin@homekeepy.com">admin@homekeepy.com</a>
      </div>

      <style>{css}</style>
    </div>
  );
};

export default Terms;

